"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HymnOfHeimdallAbilityHandler = exports.HymnOfHeimdallActorAbilityFactory = exports.HymnOfHeimdallAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class HymnOfHeimdallAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.HymnOfHeimdall;
        this.__typeName = "HymnOfHeimdall";
    }
}
exports.HymnOfHeimdallAbilityArgs = HymnOfHeimdallAbilityArgs;
let HymnOfHeimdallActorAbilityFactory = class HymnOfHeimdallActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("HymnOfHeimdall", "AllAllies", 4);
    }
};
HymnOfHeimdallActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("HymnOfHeimdall")
], HymnOfHeimdallActorAbilityFactory);
exports.HymnOfHeimdallActorAbilityFactory = HymnOfHeimdallActorAbilityFactory;
let HymnOfHeimdallAbilityHandler = class HymnOfHeimdallAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.PassiveBuffEffectArgs("Hymn of Heimdall", "Increases the critical strike chance of all allies by 5%", new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 5)),
            onApplied: sequence => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(actorId, "head", "front"), 
                // TODO: use a different animation (maybe some music notes?)
                "BeamFromTheHeavens", true));
            }
        });
    }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .forEach(ally => {
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: ally,
                        duration: Duration_1.Duration.Turns(2),
                        effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalDamageMultiplier, 50),
                        onApplied: sequence => {
                            sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(ally, "head"), 
                            // TODO: use a different animation
                            "BloodyClaws", false));
                        }
                    });
                });
            }
        });
    }
};
HymnOfHeimdallAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.HymnOfHeimdall)
], HymnOfHeimdallAbilityHandler);
exports.HymnOfHeimdallAbilityHandler = HymnOfHeimdallAbilityHandler;
